export default "__VITE_ASSET__BgLUmrzR__"